import PropTypes from 'prop-types';
import { BsBarChartLine, BsFileEarmarkText, BsPeople, BsSearch } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';

import { CompanySearchAutocomplete } from '../LeadOverviewPage/CompanySearchAutocomplete/CompanySearchAutocomplete';

const DATA_HIGHLIGHTS = [
	{ icon: BsFileEarmarkText, title: 'Stammdaten', text: 'Handelsregister, Rechtsform, Adresse & Unternehmenszweck' },
	{ icon: BsBarChartLine, title: 'Finanzen', text: 'Kennzahlen und Bilanz- & GuV-Historie über mehrere Jahre' },
	{ icon: BsPeople, title: 'Personen', text: 'Geschäftsführung und Ansprechpartner mit Kontaktdaten' },
];

const CompanySearchCard = ({ className }) => (
	<SectionCard
		className={className}
		title="Unternehmen suchen"
		subtitle="Mindestens 2 Zeichen des Firmennamens eingeben"
		icon={BsSearch}
		headerAction={<span className="flex-shrink-0 text-xs text-bgBase-800">Daten: Northdata</span>}
		bodyClassName="space-y-5"
	>
		<CompanySearchAutocomplete />
		<ul className="grid gap-3 sm:grid-cols-3">
			{DATA_HIGHLIGHTS.map(({ icon: Icon, title, text }) => (
				<li key={title} className="flex gap-3 rounded-control bg-bgBase-300 p-3">
					<div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-control bg-primary-100 text-primary-600">
						<Icon className="h-4 w-4" />
					</div>
					<div className="min-w-0">
						<p className="text-sm font-semibold text-text">{title}</p>
						<p className="mt-0.5 text-xs text-bgBase-800">{text}</p>
					</div>
				</li>
			))}
		</ul>
	</SectionCard>
);

CompanySearchCard.propTypes = {
	className: PropTypes.string,
};

export default CompanySearchCard;
